module.exports = __webpack_public_path__ + "img/phase1-2011-03.f7370036.jpg";